const configJson = {
    headers: {
        "Content-Type": "application/json",
    },
};
const configFormData = {
    headers: {
        "Content-Type": "multipart/form-data",
    },
};
const configUrlEncoded = {
    headers: {
        "Content-Type": "application/x-www-form-urlencoded",
    },
};
export {
    configFormData, configJson, configUrlEncoded
}